var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e8e98;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #363c4f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.5,13.8c-.13,0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35,0-.14,.05-.26,.15-.36,.04-.04,.1-.08,.16-.1,.18-.08,.4-.04,.54,.1,.1,.1,.15,.22,.15,.36,0,.13-.05,.26-.15,.35-.09,.1-.22,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.75,13.3c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.27-.22,.5-.5,.5h0c-.28,0-.5-.23-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,13.8c-.13,0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35,0-.14,.05-.26,.15-.36,.14-.14,.36-.18,.54-.1,.06,.02,.12,.06,.16,.1,.1,.1,.15,.22,.15,.36,0,.13-.05,.26-.15,.35-.09,.1-.22,.15-.35,.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,13.8c-.13,0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35,0-.14,.05-.26,.15-.36,.14-.14,.36-.18,.54-.1,.06,.02,.12,.06,.16,.1,.1,.1,.15,.22,.15,.36,0,.13-.05,.26-.15,.35-.09,.1-.21,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.25,13.3c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.27-.22,.5-.5,.5h0c-.28,0-.5-.23-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,13.8c-.13,0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35,0-.14,.05-.26,.15-.36,.19-.18,.51-.18,.71,0,.04,.05,.08,.11,.1,.17,.03,.06,.04,.12,.04,.19,0,.13-.05,.26-.14,.35-.1,.1-.22,.15-.36,.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.5,9.8c-.13,0-.26-.05-.35-.15-.05-.04-.09-.1-.11-.16-.03-.06-.04-.13-.04-.19,0-.13,.05-.26,.15-.36,.18-.18,.52-.18,.7,0,.1,.1,.15,.23,.15,.36,0,.06-.01,.13-.04,.19-.02,.06-.06,.12-.11,.16-.09,.1-.22,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,7.13c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Zm0-2.17c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.5,3.3c-.13,0-.26-.06-.35-.15-.1-.09-.15-.22-.15-.35s.05-.26,.15-.36c.18-.18,.52-.18,.7,0,.1,.1,.15,.23,.15,.36s-.05,.26-.15,.35c-.09,.09-.22,.15-.35,.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,7.3c-.06,0-.13,0-.19-.04-.06-.02-.12-.06-.16-.11-.05-.04-.09-.1-.11-.16-.03-.06-.04-.13-.04-.19,0-.13,.05-.26,.15-.36,.04-.04,.1-.08,.16-.1,.12-.05,.26-.05,.38,0,.06,.02,.12,.06,.16,.1,.1,.1,.15,.23,.15,.36,0,.06-.01,.13-.04,.19-.02,.06-.06,.12-.11,.16-.04,.05-.1,.09-.16,.11-.06,.03-.13,.04-.19,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,4.8c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.27-.22,.5-.5,.5h0c-.28,0-.5-.23-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,3.3c-.07,0-.13-.02-.19-.04-.06-.03-.12-.06-.16-.11-.1-.09-.15-.22-.15-.35s.05-.26,.15-.36c.04-.04,.1-.08,.16-.11,.18-.07,.4-.03,.54,.11,.1,.1,.15,.22,.15,.36,0,.06-.01,.13-.04,.19-.02,.06-.06,.11-.11,.16-.09,.09-.22,.15-.35,.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.5,26.21c-.13,0-.26-.06-.35-.15-.05-.05-.09-.1-.11-.16-.03-.07-.04-.13-.04-.2,0-.06,0-.13,.04-.19,.02-.06,.06-.11,.11-.16,.14-.14,.36-.19,.54-.11,.06,.03,.12,.06,.16,.11,.05,.05,.09,.1,.11,.16,.03,.06,.04,.13,.04,.19,0,.07-.01,.13-.04,.2-.02,.06-.06,.11-.11,.16-.09,.09-.22,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,23.73c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.51-.5,.51h0c-.28,0-.5-.23-.5-.51Zm0-1.96c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.27-.22,.5-.5,.5h0c-.28,0-.5-.23-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.5,20.3c-.14,0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35,0-.07,0-.13,.04-.19,.02-.06,.06-.12,.11-.16,.14-.15,.36-.19,.54-.11,.06,.02,.12,.06,.16,.11,.05,.04,.09,.1,.11,.16,.03,.06,.04,.12,.04,.19,0,.13-.05,.26-.15,.35-.09,.1-.21,.15-.35,.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,26.21c-.13,0-.26-.06-.35-.15-.05-.05-.09-.1-.11-.16-.03-.07-.04-.13-.04-.2,0-.06,0-.13,.04-.19,.02-.06,.06-.11,.11-.16,.04-.05,.1-.08,.16-.11,.18-.08,.4-.03,.54,.11,.05,.05,.09,.1,.11,.16,.03,.06,.04,.13,.04,.19,0,.07-.01,.13-.04,.2-.02,.06-.06,.11-.11,.16-.09,.09-.22,.15-.35,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,23.6c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Zm0-2.1c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Zm0-2.1c0-.28,.22-.5,.5-.5h0c.28,0,.5,.22,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,17.8c-.13,0-.26-.05-.35-.15-.1-.09-.15-.22-.15-.35,0-.07,0-.13,.04-.19,.02-.06,.06-.12,.11-.17,.14-.14,.36-.18,.54-.1,.06,.02,.12,.06,.16,.1,.05,.05,.09,.11,.11,.17,.03,.06,.04,.12,.04,.19,0,.13-.05,.26-.15,.35-.04,.05-.1,.09-.16,.11-.06,.03-.12,.04-.19,.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.5,29.7H1.5v-4.5H30.5v4.5Zm-28-1H29.5v-2.5H2.5v2.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 25.7,
    width: 28,
    height: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.5,29.7H1.5v-4.5H30.5v4.5Zm-28-1H29.5v-2.5H2.5v2.5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.5,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.5,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.5,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.5,
    y: 25.7,
    width: 1,
    height: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.5 22.8 17.5 12.3 6.5 9.3 6.5 19.8 17.5 22.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.5 22.8 17.5 12.3 25.5 6.8 25.5 17.3 17.5 22.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.5 6.8 17.5 12.3 6.5 9.3 14.5 3.8 25.5 6.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.59 12.84 6.37 9.78 6.63 8.82 17.41 11.75 25.22 6.39 25.78 7.21 17.59 12.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.59,23.34l-11.59-3.16V9.03L14.41,3.25l11.59,3.16v11.14l-8.41,5.78Zm-10.59-3.93l10.41,2.84,7.59-5.22V7.18l-10.41-2.84-7.59,5.22v9.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17,
    y: 12.3,
    width: 1,
    height: 10.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/Dimensions.12087f922598dc8fef8a1a6e654bcd34.svg";
export { ForwardRef as ReactComponent };